import { render, staticRenderFns } from "./FieldType9.vue?vue&type=template&id=37439b85&scoped=true"
import script from "./FieldType9.vue?vue&type=script&lang=js"
export * from "./FieldType9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37439b85",
  null
  
)

export default component.exports